import { useRef, useState, useEffect } from "react";
import { Button } from "../buttons/Button/Button";
import "./input.css";

export const Input = ({ type = '', placeholder = '', name = '', onChange = () => {}, value = '', pattern='' }) => {
  const [inputValue, setInputValue] = useState(value);
  const ref = useRef(null);

  const onClear = () => {
    ref.current.value = null;
    setInputValue("");
    };
    
    useEffect(() => {
        setInputValue(value)
    }, [value])

  return (
    <div>
      <input
        pattern={pattern}
        className={`input ${type}`}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        ref={ref}
        type={type}
      />
      <p className="body3">INCORRECT VALUE</p>
      {inputValue && (
        <Button type="clear" onClick={onClear}>
          CLEAR
        </Button>
      )}
    </div>
  );
};
